//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faChevronsUp } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'SubscribeScrollToTop',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      faChevronsUp,
      imageBaseUrl: 'https://static.moele.me/img/channels2022/subscription/are-you-ready.png?auto=format&w=324',
      imageBaseUrlMobile: 'https://static.moele.me/img/channels2022/subscription/are-you-ready-m.png?auto=format&w=242',
    };
  },
};
